module.exports = __webpack_public_path__ + "img/图1-23分规的用法.ce28e141.png";